<div class="delete-check-dialog">
  <nz-alert
    *ngIf="hasAnyItems()"
    nzType="warning"
    nzMessage="Warning"
    nzDescription="This asset is associated with other records. Please review and delete associated items before proceeding."
    [nzShowIcon]="true"
    [nzCloseable]="false"
    class="mb-3">
  </nz-alert>

  <div class="data-section">
    <div *ngFor="let section of getDisplayData(); let last = last" class="data-group" [class.mb-3]="!last">
      <div class="group-header" (click)="toggleSection(section.key)">
        <i [class]="expandedSection[section.key] && section.items && section.items.length > 0 ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" class="me-2"></i>
        <span class="group-title">{{ section.title }}</span>
        <span class="badge badge-info ms-2">{{ section.items?.length || 0 }}</span>
      </div>

      <div *ngIf="expandedSection[section.key] && section.items && section.items.length > 0" class="group-content">
        <div class="table-wrapper">
          <table class="table table-sm table-bordered">
            <thead *ngIf="section.showDeleteBtn">
              <tr>
                <th class="checkbox-col">
                  <input
                    type="checkbox"
                    [checked]="isAllSelected(section)"
                    (change)="toggleSelectAll(section)"
                    class="delete-form-check-input"
                  />
                </th>
                <th>ID</th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of section.items; let i = index">
                <td *ngIf="section.showDeleteBtn" class="checkbox-col">
                  <input
                    type="checkbox"
                    [checked]="isItemSelected(section, item)"
                    (change)="toggleItemSelection(section, item)"
                    class="delete-form-check-input"
                  />
                </td>
                <td class="id-cell" [class.no-checkbox]="!section.showDeleteBtn">{{ item }}</td>
                <td *ngIf="section.key === 'arIds' || section.key === 'stageIds'" class="action-col">
                  <i
                    class="fas fa-fw fa-bars"
                    id="moreDetail"
                    style="margin-right:3px; cursor: pointer;"
                    (click)="section.key === 'arIds' ? showArDetail(item) : showStageDetail(item)"
                    title="View details">
                  </i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Batch Delete Button for deletable sections -->
        <div *ngIf="section.showDeleteBtn" class="action-footer">
          <button
            class="btn btn-sm btn-danger"
            [disabled]="section.selectedItems.size === 0 || isDeleting"
            (click)="section.key === 'arIds' ? batchDeleteAr() : batchDeleteStage()">
            <i class="fas fa-trash me-1"></i>
            Delete Selected ({{ section.selectedItems.size }})
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div nz-modal-footer style="margin-top: 8px;">
  <button nz-button nzType="default" (click)="onCancel()" [disabled]="isDeleting" style="margin-right: 8px;">Cancel</button>
  <button
    nz-button
    nzType="primary"
    nzDanger
    (click)="onDelete()"
    [disabled]="hasAnyItems() || isDeleting">
    Confirm Delete Asset
  </button>
</div>


